
export class ContextoNomeacao {
  static EMISSAO = "EMISSAO";
  static CADASTRO = "CADASTRO";
}
    
export class TipoNomeacao {
  static CARTA_NOMEACAO = "CARTA_NOMEACAO";
  static AUTOMATICA = "AUTOMATICA";
  static DOCUMENTO_CCG = "DOCUMENTO_CCG";
}
    
export class ContatoPerfil {
  static ADMIN_SUSEP = "ADMIN_SUSEP";
  static ADMIN = "ADMIN";
  static CORRETOR = "CORRETOR";
}
    
export class TipoComissao {
  static CORRETAGEM = "CORRETAGEM";
  static PRO_LABORE = "PRO_LABORE";
}
    
export class TipoPessoa {
  static FISICA = "FISICA";
  static JURIDICA = "JURIDICA";
  static ORGAO_PUBLICO = "ORGAO_PUBLICO";
  static CONSORCIO = "CONSORCIO";
  static PJ_ESTRANGEIRO = "PJ_ESTRANGEIRO";
  static PF_ESTRANGEIRO = "PF_ESTRANGEIRO";
  static OUTRAS = "OUTRAS";
  static SUBSIDIARIA = "SUBSIDIARIA";
}
    
export class PapelPessoa {
  static TOMADOR = "TOMADOR";
  static SEGURADO = "SEGURADO";
  static CONJUGE = "CONJUGE";
  static FIADOR = "FIADOR";
  static REPRESENTANTE_LEGAL = "REPRESENTANTE_LEGAL";
  static SOCIO_PROPRIETARIO = "SOCIO_PROPRIETARIO";
  static ACIONISTA = "ACIONISTA";
  static CORRETOR = "CORRETOR";
  static CONTATO = "CONTATO";
  static ESTIPULANTE = "ESTIPULANTE";
}
    
export class CategoriaCCG {
  static REPRESENTANTES = "REPRESENTANTES";
  static FIADORES = "FIADORES";
}
    
export class TipoDocumentoCCG {
  static CCG_GARANTIA = "CCG_GARANTIA";
}
    
export class StatusDocumentoCCG {
  static FORMALIZADO = "FORMALIZADO";
  static NAO_FORMALIZADO = "NAO_FORMALIZADO";
  static EM_TRANSITO = "EM_TRANSITO";
}
    
export class StatusNomeacao {
  static EM_TRANSITO = "EM_TRANSITO";
  static FORMALIZADA = "FORMALIZADA";
  static NAO_FORMALIZADA = "NAO_FORMALIZADA";
}
    
export class StatusDocumento {
  static EM_TRANSITO = "EM_TRANSITO";
  static FORMALIZADA = "FORMALIZADA";
  static NAO_FORMALIZADA = "NAO_FORMALIZADA";
  static DEVOLVIDA_CORRETOR = "DEVOLVIDA_CORRETOR";
  static DEVOLVIDA_TOMADOR = "DEVOLVIDA_TOMADOR";
  static DISPENSADO = "DISPENSADO";
  static EM_ANALISE = "EM_ANALISE";
}
    
export class StatusNomeado {
  static CORRETOR_NOMEADO = "CORRETOR_NOMEADO";
  static OUTRO_NOMEADO = "OUTRO_NOMEADO";
  static SEM_NOMEACAO = "SEM_NOMEACAO";
}
    
export class DominioArquivo {
  static TOMADOR = "TOMADOR";
  static CORRETOR = "CORRETOR";
  static SEGURADO = "SEGURADO";
  static ENDOSSO = "ENDOSSO";
}
    
export class NaturezaJuridica {
  static PUBLICA = "PUBLICA";
  static PRIVADA = "PRIVADA";
  static RECURSAL = "RECURSAL";
}
    
export class StatusProposta {
  static EM_CADASTRO = "EM_CADASTRO";
  static EMITIDA = "EMITIDA";
  static CANCELADA = "CANCELADA";
  static RECUSADA = "RECUSADA";
  static SEGURADORA_ANALISE_CREDITO = "SEGURADORA_ANALISE_CREDITO";
  static CORRETOR_ANALISE_CREDITO = "CORRETOR_ANALISE_CREDITO";
  static SEGURADORA_ANALISE_SUBSCRICAO = "SEGURADORA_ANALISE_SUBSCRICAO";
  static CORRETOR_ANALISE_SUBSCRICAO = "CORRETOR_ANALISE_SUBSCRICAO";
  static SEGURADORA_ANALISE_RESSEGURO = "SEGURADORA_ANALISE_RESSEGURO";
  static CORRETOR_ANALISE_RESSEGURO = "CORRETOR_ANALISE_RESSEGURO";
  static SEGURADORA_ANALISE_EMISSAO = "SEGURADORA_ANALISE_EMISSAO";
  static CORRETOR_ANALISE_EMISSAO = "CORRETOR_ANALISE_EMISSAO";
}
    
export class TipoFollowUpProposta {
  static TIMELINE_DATA_ENVIO_ANALISE = "TIMELINE_DATA_ENVIO_ANALISE";
  static TIMELINE_INICIO_ACAO_SEGURADORA_CREDITO = "TIMELINE_INICIO_ACAO_SEGURADORA_CREDITO";
  static TIMELINE_TERMINO_ACAO_SEGURADORA_CREDITO = "TIMELINE_TERMINO_ACAO_SEGURADORA_CREDITO";
  static TIMELINE_INICIO_ACAO_CORRETOR_CREDITO = "TIMELINE_INICIO_ACAO_CORRETOR_CREDITO";
  static TIMELINE_TERMINO_ACAO_CORRETOR_CREDITO = "TIMELINE_TERMINO_ACAO_CORRETOR_CREDITO";
  static TIMELINE_INICIO_ACAO_SEGURADORA_SUBSCRICAO = "TIMELINE_INICIO_ACAO_SEGURADORA_SUBSCRICAO";
  static TIMELINE_TERMINO_ACAO_SEGURADORA_SUBSCRICAO = "TIMELINE_TERMINO_ACAO_SEGURADORA_SUBSCRICAO";
  static TIMELINE_INICIO_ACAO_CORRETOR_SUBSCRICAO = "TIMELINE_INICIO_ACAO_CORRETOR_SUBSCRICAO";
  static TIMELINE_TERMINO_ACAO_CORRETOR_SUBSCRICAO = "TIMELINE_TERMINO_ACAO_CORRETOR_SUBSCRICAO";
  static TIMELINE_INICIO_ACAO_SEGURADORA_RESSEGURO = "TIMELINE_INICIO_ACAO_SEGURADORA_RESSEGURO";
  static TIMELINE_TERMINO_ACAO_SEGURADORA_RESSEGURO = "TIMELINE_TERMINO_ACAO_SEGURADORA_RESSEGURO";
  static TIMELINE_INICIO_ACAO_CORRETOR_RESSEGURO = "TIMELINE_INICIO_ACAO_CORRETOR_RESSEGURO";
  static TIMELINE_TERMINO_ACAO_CORRETOR_RESSEGURO = "TIMELINE_TERMINO_ACAO_CORRETOR_RESSEGURO";
  static TIMELINE_INICIO_ACAO_SEGURADORA_EMISSAO = "TIMELINE_INICIO_ACAO_SEGURADORA_EMISSAO";
  static TIMELINE_TERMINO_ACAO_SEGURADORA_EMISSAO = "TIMELINE_TERMINO_ACAO_SEGURADORA_EMISSAO";
  static TIMELINE_INICIO_ACAO_CORRETOR_EMISSAO = "TIMELINE_INICIO_ACAO_CORRETOR_EMISSAO";
  static TIMELINE_TERMINO_ACAO_CORRETOR_EMISSAO = "TIMELINE_TERMINO_ACAO_CORRETOR_EMISSAO";
  static TIMELINE_DATA_ENVIO_EMISSAO = "TIMELINE_DATA_ENVIO_EMISSAO";
  static TIMELINE_DATA_EMISSAO = "TIMELINE_DATA_EMISSAO";
  static TIMELINE_DATA_RECUSA = "TIMELINE_DATA_RECUSA";
  static TIMELINE_DATA_DESISTENCIA = "TIMELINE_DATA_DESISTENCIA";
  static COMUNICACAO_SEGURADORA_PARA_CORRETOR = "COMUNICACAO_SEGURADORA_PARA_CORRETOR";
  static COMUNICACAO_CORRETOR_PARA_SEGURADORA = "COMUNICACAO_CORRETOR_PARA_SEGURADORA";
  static COMUNICACAO_ACEITE_TERMOS_DECLARACAO = "COMUNICACAO_ACEITE_TERMOS_DECLARACAO";
  static TIMELINE_PROCESSO_AUTOMATICO = "TIMELINE_PROCESSO_AUTOMATICO";
  static NUMERO_APOLICE_REEMISSAO = "NUMERO_APOLICE_REEMISSAO";
}
    
export class TipoFollowUpTomador {
  static COMUNICACAO_TOMADOR_SEGURADORA_PARA_CORRETOR = "COMUNICACAO_TOMADOR_SEGURADORA_PARA_CORRETOR";
  static COMUNICACAO_TOMADOR_CORRETOR_PARA_SEGURADORA = "COMUNICACAO_TOMADOR_CORRETOR_PARA_SEGURADORA";
}
    
export class TipoImposto {
  static CSLL = "CSLL";
  static IRRF = "IRRF";
  static ISS = "ISS";
}
    
export class RamoAtividade {
  static CORRETOR_SEGUROS = "CORRETOR_SEGUROS";
}
    
export class TipoDocumentoArquivo {
  static DOCUMENTO = "DOCUMENTO";
  static ENDOSSO = "ENDOSSO";
  static OUTROS_SUBSCRICAO = "OUTROS_SUBSCRICAO";
}
    
export class QuestionamentoDocumentos {
  static CARTA_DE_NOMEACAO = "CARTA_DE_NOMEACAO";
  static CARTA_DE_NOMEACAO_AUTOMATICA = "CARTA_DE_NOMEACAO_AUTOMATICA";
  static CARTA_DE_NOMEACAO_CGG = "CARTA_DE_NOMEACAO_CGG";
  static CARTA_DE_RENOVACAO = "CARTA_DE_RENOVACAO";
  static COMPROVANTE_DE_RESIDENCIA = "COMPROVANTE_DE_RESIDENCIA";
  static CPF_RG_OU_PASSAPORTE_DO_BENEFICIARIO = "CPF_RG_OU_PASSAPORTE_DO_BENEFICIARIO";
  static CPF_RG_OU_PASSAPORTE_DO_SEGURADO = "CPF_RG_OU_PASSAPORTE_DO_SEGURADO";
}
    
export class CadastroEstado {
  static REVISADO = "REVISADO";
  static NAO_REVISADO = "NAO_REVISADO";
  static NAO_SE_APLICA = "NAO_SE_APLICA";
}
    
export class SubLimiteGrupoCoberturasTomador {
  static PUBLICO_JUD_TRAB_JUD_REC_PAG = "PUBLICO_JUD_TRAB_JUD_REC_PAG";
  static PUBLICO_TRADICIONAIS = "PUBLICO_TRADICIONAIS";
  static PRIVADO_IMOBILIARIO = "PRIVADO_IMOBILIARIO";
  static PUBLICO_CONCESSAO_ANEEL = "PUBLICO_CONCESSAO_ANEEL";
  static PUBLICO_JUDICIAL_CIVEL_FISC = "PUBLICO_JUDICIAL_CIVEL_FISC";
  static PUBLICO_TRADICIONAIS_RAMOS_NEG = "PUBLICO_TRADICIONAIS_RAMOS_NEG";
  static PRIVADO_FINANCEIRAS = "PRIVADO_FINANCEIRAS";
  static PRIVADO_TRADICIONAIS = "PRIVADO_TRADICIONAIS";
  static PRIVADO_ENERGIA_CUST_CUSD = "PRIVADO_ENERGIA_CUST_CUSD";
  static PRIVADO_TRADICIONAIS_RAMOS_NEG = "PRIVADO_TRADICIONAIS_RAMOS_NEG";
}
    
export class ModalidadesGrupos {
  static TRADICIONAIS = "TRADICIONAIS";
  static FINANCEIRAS = "FINANCEIRAS";
}
    
export class StatusPropostaPipes {
  static EM_CADASTRO = "";
  static SEGURADORA_ANALISE_CREDITO = "CREDITO";
  static CORRETOR_ANALISE_CREDITO = "CREDITO";
  static SEGURADORA_ANALISE_SUBSCRICAO = "SUBSCRICAO";
  static CORRETOR_ANALISE_SUBSCRICAO = "SUBSCRICAO";
  static SEGURADORA_ANALISE_RESSEGURO = "SUBSCRICAO";
  static CORRETOR_ANALISE_RESSEGURO = "SUBSCRICAO";
  static SEGURADORA_ANALISE_EMISSAO = "EMISSAO";
  static CORRETOR_ANALISE_EMISSAO = "EMISSAO";
}
    
export class TipoApolice {
  static INDIVIDUAL = "INDIVIDUAL";
  static COLETIVA = "COLETIVA";
}
    
export class StatusApoliceColetiva {
  static EM_ANALISE = "EM_ANALISE";
  static APROVADA = "APROVADA";
  static REPROVADA = "REPROVADA";
}
    
export class TipoCombustivel {
  static ALCOOL = "ALCOOL";
  static GASOLINA = "GASOLINA";
  static DIESEL = "DIESEL";
  static FLEX = "FLEX";
  static GNV = "GNV";
  static ELETRICO = "ELETRICO";
}
    
export class TipoNacionalidadeVeiculo {
  static NACIONAL = "NACIONAL";
  static IMPORTADO = "IMPORTADO";
}
    
export class TipoCoberturaMecanica {
  static MOTOR_CAMBIO_CARRO_NACIONAL = "MOTOR_CAMBIO_CARRO_NACIONAL";
  static MOTOR_CAMBIO_CARRO_IMPORTADO = "MOTOR_CAMBIO_CARRO_IMPORTADO";
  static MOTOR_CAMBIO_MOTORES_DIESEL = "MOTOR_CAMBIO_MOTORES_DIESEL";
  static FUTURA_CARRO_NACIONAL = "FUTURA_CARRO_NACIONAL";
  static FUTURA_CARRO_IMPORTADO = "FUTURA_CARRO_IMPORTADO";
  static FUTURA_MOTORES_DIESEL = "FUTURA_MOTORES_DIESEL";
  static PRIME_CARRO_NACIONAL = "PRIME_CARRO_NACIONAL";
  static PRIME_CARRO_IMPORTADO = "PRIME_CARRO_IMPORTADO";
  static PRIME_MOTORES_DIESEL = "PRIME_MOTORES_DIESEL";
}
    
export class TipoAuto {
  static PASSEIO = "PASSEIO";
}
    
export class SituacaoPatrimonial {
  static MICRO_EMPRESA = "MICRO_EMPRESA";
  static PEQUENA_EMPRESA = "PEQUENA_EMPRESA";
  static MEDIA_EMPRESA = "MEDIA_EMPRESA";
  static GRANDE_EMPRESA = "GRANDE_EMPRESA";
}
    
export class UF {
  static AC = "AC";
  static AL = "AL";
  static AP = "AP";
  static AM = "AM";
  static BA = "BA";
  static CE = "CE";
  static DF = "DF";
  static ES = "ES";
  static GO = "GO";
  static MA = "MA";
  static MT = "MT";
  static MS = "MS";
  static MG = "MG";
  static PA = "PA";
  static PB = "PB";
  static PR = "PR";
  static PE = "PE";
  static PI = "PI";
  static RJ = "RJ";
  static RN = "RN";
  static RS = "RS";
  static RO = "RO";
  static RR = "RR";
  static SC = "SC";
  static SP = "SP";
  static SE = "SE";
  static TO = "TO";
}
    
export class StatusCorretor {
  static NAO_CADASTRADO = "NAO_CADASTRADO";
  static NAO_ANALISADO = "NAO_ANALISADO";
  static EM_CADASTRO = "EM_CADASTRO";
  static EM_ANALISE = "EM_ANALISE";
  static APROVADO = "APROVADO";
  static REPROVADO = "REPROVADO";
}
    
export class StatusDocumentoCorretor {
  static EM_TRANSITO = "EM_TRANSITO";
  static FORMALIZADA = "FORMALIZADA";
  static NAO_FORMALIZADA = "NAO_FORMALIZADA";
  static DEVOLVIDA_CORRETOR = "DEVOLVIDA_CORRETOR";
  static DISPENSADO = "DISPENSADO";
}
    
export class StatusDocumentoEnviado {
  static FORMALIZADO = "FORMALIZADO";
  static NAO_FORMALIZADO = "NAO_FORMALIZADO";
  static EM_ANALISE = "EM_ANALISE";
}
    
export class ClassificacaoCorretor {
  static G_VIP = "G_VIP";
  static DIGITAL = "DIGITAL";
  static DIGITAL_VIP = "DIGITAL_VIP";
}
    



// WEBPACK FOOTER //
// ./src/enums.js